import { lightTheme } from '@/customTheme'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Separator from '../../FloatingInspectorButton/Buttons/Separator'
import CloseIcon from '../../FloatingInspectorButton/FloatingIcons/CloseIcon'
import { FloatingInspectorButtonIcon, FloatingInspectorButtonText } from '../../FloatingInspectorButton/FloatingInspectorButtons'
import WrappingFloatingInspector from '../../FloatingInspectorButton/SharedComponents/WrappingFloatingInspector'
import { RoundedType } from '../../FloatingInspectorButton/SharedComponents/WrappingFloatingInspector/WrappingFloatingInspector'
import CheckIcon from '@/components/icons/CheckIcon'
import EditIcon from '@/components/icons/EditIcon'
import GenerateIcon from '@/components/icons/GenerateIcon'
import SlideInAnimation from '@/components/SlideInAnimation'
import { EDIT_WITH_AI_POST_GENERATION_ID } from '@/constants/editWithAiDom'

type PostGenerationProps = {
  prompt: string
  onEditClick: () => void
  onRegenerateClick: () => void
  onCloseClick: () => void
  isVisible: boolean
  maxWidth?: number
}

function EditWithAIPostGeneration({prompt, onEditClick, onRegenerateClick, onCloseClick, isVisible, maxWidth}: PostGenerationProps) {
  const { t } = useTranslation()
  return (
    <SlideInAnimation
      isVisible={isVisible}
      direction='up'
      id={EDIT_WITH_AI_POST_GENERATION_ID}
      hideWithAnimation={false}
    >
      <WrappingFloatingInspector
        rounded={RoundedType.ROUND}
        style={{
          width: 'fit-content',
          maxWidth: maxWidth ? `${maxWidth}px` : '600px',
          position: 'relative',
          paddingLeft: '8px' // extra padding for the check icon
        }}
      >
          <FloatingInspectorButtonIcon icon={<CheckIcon />} onClick={() => {}} borderRadiusStyle='rounded' nonInteractive />
          <FloatingInspectorButtonText text={`"${prompt}"`} onClick={() => {}} nonInteractive fontWeight={400} tooltipText={`"${prompt}"`} style={{ padding:'4px 0' }}/>
          <FloatingInspectorButtonIcon icon={<EditIcon />} onClick={onEditClick} borderRadiusStyle='rounded' tooltipText={t('Edit prompt')} />
          <FloatingInspectorButtonIcon icon={<GenerateIcon />} onClick={onRegenerateClick} borderRadiusStyle='rounded' tooltipText={t('Create again')}/>
          <Separator />
          <FloatingInspectorButtonIcon icon={<CloseIcon />} onClick={onCloseClick} borderRadiusStyle='rounded' tooltipText={t('Close')} style={{
            background: lightTheme.colors.grayScale50,
            ':hover': {
              background: `${lightTheme.colors.grayScale100}!important`,
            },
            ':active': {
              background: `${lightTheme.colors.grayScale150}!important`,
            }
          }} />
      </WrappingFloatingInspector>
    </SlideInAnimation>
  )
}

export default EditWithAIPostGeneration